import { render, staticRenderFns } from "./cg-misc-legal.vue?vue&type=template&id=dde3669c&scoped=true"
import script from "./cg-misc-legal.vue?vue&type=script&lang=js"
export * from "./cg-misc-legal.vue?vue&type=script&lang=js"
import style0 from "./cg-misc-legal.vue?vue&type=style&index=0&id=dde3669c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde3669c",
  null
  
)

export default component.exports